import type {
  ClientLoaderFunctionArgs,
  LinksFunction,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadCategoryRoute } from '@jane/bloom/loaders/routes/category.server';
import { categoryRouteMeta } from '@jane/bloom/resources/meta/routes/category';
import { plpStylesLinks } from '@jane/bloom/resources/plpStylesLinks';

export const links: LinksFunction = () => [...plpStylesLinks];

export const meta: MetaFunction<typeof loader> = (args) => {
  return categoryRouteMeta(args);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  loadCategoryRoute({
    args,
    shouldPinStore: Boolean(args.params['storeSlug']),
  });

export { productGridShouldRevalidate as shouldRevalidate } from '@jane/bloom/utils/routes/shouldRevalidate';

export { CategoryRouteComponent as default } from '@jane/bloom/components/routes/category/categoryRouteComponent';
